import DepositCardSettings from "@/models/Products/ProductSettings/DefaultSettings/Cards/DepositCardSettings";

export default class AccountDepositCardSettings extends DepositCardSettings {
    overridden: boolean = false;
}
